import ReactMarkdown, { Components } from 'react-markdown';
import remarkBreaks from 'remark-breaks';

import Link from './govuk/Link';

const components: Components = {
  a: ({ href, children }) => (
    <Link to={href} target="_blank">
      {children}
    </Link>
  ),
};

type MarkdownProps = {
  children?: string;
};

export default function Markdown({ children }: MarkdownProps) {
  if (!children) return null;

  return (
    <ReactMarkdown remarkPlugins={[remarkBreaks]} components={components}>
      {children}
    </ReactMarkdown>
  );
}
